"use client";

import { c as _c } from "react/compiler-runtime";
import { debug } from "../../../shared/utils/debug.js";
import { useQuery } from "@tanstack/react-query";
async function fetchGeoData() {
  const response = await fetch("https://geo.basement.fun/");
  if (!response.ok) {
    throw new Error("Failed to fetch geo data");
  }
  return response.json();
}
export function useGetGeo() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["useGetGeo"],
      queryFn: fetchGeoData,
      retry: 3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: geoData,
    isLoading: loading,
    error
  } = useQuery(t0);
  if (error) {
    debug("@@useGetGeo error fetching geo data", error);
  }
  let t1;
  if ($[1] !== error || $[2] !== geoData || $[3] !== loading) {
    t1 = {
      geoData,
      loading,
      error
    };
    $[1] = error;
    $[2] = geoData;
    $[3] = loading;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}